import { MainContent, TopBar } from '@domain-group/suit-theme'

import useMainNavigation from '@hooks/useMainNavigation'

import DashboardSearch from '@components/DashboardSearch'
import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Client/components/MainNavigation'
import Notifications from '@components/Notifications'

import DashboardRoutes from './routes'

const Dashboard = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  return (
    <>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        notificationsComponent={<Notifications />}
        offset={{ left: 220 }}
        searchComponent={<DashboardSearch />}
      />

      {/*
       // @ts-expect-error TS2739 */}
      <MainNavigation />

      <MainContent offset={{ left: 220, top: TopBar.topBarHeight }}>
        <DashboardRoutes />
      </MainContent>
    </>
  )
}

export default Dashboard
